import * as React from 'react';

import { StyledComponent } from 'styled-components';

import ErrorBoundary from '@components/ErrorBoundary';
import { HorizontalChevron } from '@sharedComponents/Icons/HorizontalChevron';

import { Title, ChevronIconWrapper, TitleButton } from './styled';

export interface ISubtitleProps
  extends Omit<React.HTMLAttributes<Element>, 'title'> {
  isExpanded?: boolean;
  title?: string | React.ReactNode;
  handleExpand?: (e: React.SyntheticEvent | React.KeyboardEvent) => void;
  newPdDesignEnabled: boolean;
}

export const TabTitle: React.FC<ISubtitleProps> = ({
  isExpanded,
  title,
  handleExpand,
  role,
  ...rest
}) => {
  // eslint-disable-next-line
  const TitleComponent: StyledComponent<'button' | 'h2', any> =
    role === 'button' ? TitleButton : Title;
  return (
    <ErrorBoundary>
      <TitleComponent {...rest} onClick={handleExpand}>
        {title}
        <ChevronIconWrapper newPdDesignEnabled={rest.newPdDesignEnabled}>
          <HorizontalChevron
            color="icon.primary"
            width="16px"
            height="16px"
            isOpened={isExpanded}
          />
        </ChevronIconWrapper>
      </TitleComponent>
    </ErrorBoundary>
  );
};
